import React from "react";

const CoreFeatures = () => {
  return (
    <section id="section_core" className="chat_core_features_area sec_pad">
      <div className="container">

        <div className="hosting_title chat_title text-center">
          <h2 className="wow fadeInUp" data-wow-delay="0.2s">
            Die einfachste Art und Weise um Arbeitsabläufe zu erklären!
          </h2>
        </div>

        <div className="row">
          <div className="col-lg-12 col-md-12">
          <div className="chat_features_item wow fadeInUp" data-wow-delay="0.2s">
            <p className="chat_body">
              Wir haben unsere Lösungen zu Ende gedacht! Mit joobster erhalten Sie sämtliche 
              Tools um noch schneller und einfacher Inhalte Ihren Mitarbeitern vermitteln zu können.
            </p>
          </div>
          </div>
        </div>

        <div className="row"> 
          <div className="col-lg-4 col-md-6">
            <div className="chat_features_item wow fadeInUp" data-wow-delay="0.2s">
              <div className="round">
                <div className="round_circle two"></div>
                <img
                  className="top_img p_absoulte"
                  src={require("../../img/home-chat/triangle.png")}
                  alt=""
                />
                <img src={require('../../img/home-chat/mobile.png')} alt="" />
              </div>
              <h4>Inhalte erstellen</h4>
              <p>
                Mit joobster erhalten Sie eine vollständige Produktionssuite
                um schnell und einfach Ihre Ideen in Videos umsetzen zu können. 
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="chat_features_item wow fadeInUp">
              <div className="round">
                <div className="round_circle"></div>
                <img
                  className="top_img p_absoulte"
                  src={require("../../img/home-chat/pluse.png")}
                  alt=""
                />
                <img src={require("../../img/home-chat/chat.png")} alt="" />
              </div>
              
              <h4>Inhalte teilen</h4>
              <p>
                Sie können die Inhalte direkt über WhatsApp verteilen, oder mit zusätzlichen 
                Informationen wie PDFs, Powerpoint etc. anreichern, dazu Fragen definieren und 
                über die joobster Micro-App an Ihre Mitarbeiter ausspielen.
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="chat_features_item wow fadeInUp" data-wow-delay="0.4s">
              <div className="round">
                <div className="round_circle three"></div>
                <img
                  className="top_img p_absoulte"
                  src={require("../../img/home-chat/box.png")}
                  alt=""
                />
                <img src={require('../../img/home-chat/book.png')} alt="" />
              </div>
              
              <h4>Zertifikate verwalten</h4>
              <p>
                Sie haben immer im Überblick welche Inhalte bereits erfolgreich 
                konsumiert wurden. So gehen Sie auf Nummer sicher, dass Ihre Mitarbeiter
                ausreichend unterwiesen sind.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default CoreFeatures;
